<script setup>
import RentalItemCard from "../../../administration/components/ui-components/widget/RentalItemCard.vue";

defineProps({
    items: Array,
    theme: Object,
    roundness: String
})

const form = defineModel('form');
const currentSlide = defineModel('currentSlide');
</script>

<template>
    <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-4 m-4 my-0 mb-1">
        <rental-item-card
            v-for="item in items"
            :key="item.id"
            :item="item"
            :theme="theme"
            :roundness="roundness"
            @book="() => { form.id_rental_items = item.id; currentSlide++ }"
        ></rental-item-card>
    </div>
</template>

<style scoped lang="scss">

</style>
